import { useEffect, useState } from 'react';
import { Table, Column, Button, PageBar, FormGroup, Dialog } from '@tencent/spaui';
import _ from 'lodash';
import uuid from 'uuid/v4';
import modal from '@/utils/modal';
import { callIdTagSave } from './api';
import { columnConfig } from './config';
import HotLinePhone from '../HotLinePhone';
import DateTime from '@/components/DateTime';
import OriginalSourceInfo from '@/components/OriginalSourceInfo';
import { getMessage } from '@/utils/MessageUtils';
import CleaningStatus from '@/components/CleaningStatus';
import PotentialStatus from '@/components/PotentialStatus';
import { lgCallLabelMap, REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import LGCallLabelRadioGroup from '@/business-components/sale/LGCallLabel/LGCallLabelRadioGroup';
import UserInfo from './UserInfo';
import message from '@/utils/message';
import { computeGetUrl } from '@/utils';

interface DialInModalProps {
  Caller: string;
  whiteList: {
    data: number[]; // 直销白名单
  };
  params: {
    Callee: string; // 被叫
    CallId: string; // 来电
    switchboardNumber: string; // B侧总机号码
    isAnswered: boolean; // 接听状态
    CallTime: string; // 呼入时间
    vendor: string; // 呼叫中心类型
    sessionId: string
    callCenter: any // 呼叫中心对象 类
  };
  webApi: any;
  handleDialIn: (callId: string) => void; // 接听回调
  onClose: (Caller: string) => void; // 关闭弹框回调
}

const DialInModal = (props: DialInModalProps) => {
  const [dialInData, setDialInData] = useState<any>({});
  const [selectedId, setSelectedId] = useState<number[] | undefined>(undefined);
  const [disabledValue, setDisabledValue] = useState<number[]>([]);
  const [callTags, setCallTags] = useState<any>({
    firstTag: undefined, secondTag: undefined,
  });
  const [canChoseList, setCanChoseList] = useState<string[]>(_.map(lgCallLabelMap, (tag) => tag));
  const [memoTag, setMemoTag] = useState<string>('');
  const [show, setShow] = useState<boolean>(false);
  const { Caller, whiteList, params, webApi } = props;
  const { Callee, CallId, switchboardNumber, callCenter, isAnswered, CallTime, vendor, sessionId } = params || {};

  let disabled = false;
  // 请求拉取呼入信息
  const askDialInCheck = (page = {}) => {
    // switchboardNumber(B侧总机号码)
    webApi
      .dialInCheck()
      .ajaxJson({
        data: {
          contactPhone: Caller,
          vendor,
          displayNumber: Callee,
          uuid: uuid(),
          ...page,
        },
      })
      .then((res: any) => {
        if (res.code === 0) {
          callCenter.vendor.callInSetParams({ leadId: res.data.leadList?.items[0]?.leadId || '' } || {});
          setDialInData({ ...res.data });
          setShow(true);
        }
      })
      .catch((err: any) => {
        const { json = {} } = err;
        console.error(err, '.....dialin/check error');
        modal.error(<div className="call-err-modal">
          <p className="err-msg">呼入查询出错，来电号码为{Caller}，可记录号码用于后续跟进。 </p>
          <br />
          <p>错误信息 {err?.message}</p>
          <p>trace_id: {json?.trace_id || err?.trace_id}</p>
        </div>);
        setShow(true);
      });
  };

  useEffect(() => {
    if (!sessionId) return;
    setMemoTag('');
    setCallTags({
      firstTag: undefined, secondTag: undefined,
    });
    askDialInCheck();
  }, [sessionId]);

  const handleChangePage = (e: any, value: number) => {
    askDialInCheck({
      pageIndex: value - 1,
    });
  };

  const handleDialIn = () => {
    if (isAnswered) return;
    props?.handleDialIn(props?.params?.CallId);
  };

  const renderDialHead = () => {
    const { conf } = dialInData?.leadList || {};
    return (
      <div className="dial-in-head">
        <p>
          来电号码: {Caller} 被叫: {Callee} {Callee && <HotLinePhone phoneNumber={Callee} />}
          <Button displayType="primary" disabled={isAnswered} onClick={handleDialIn}>
            {isAnswered ? '已' : null}接听
          </Button>
        </p>
        <p>关联线索 {conf?.totalCount || 0} 条</p>
      </div>
    );
  };

  const renderStatus = (value: any, data: any) => {
    const { cleaningStatus, potential, order } = data;
    if (value) {
      switch (data.progressStatus) {
        case 'PROGRESS_STATUS_LEAD':
          return <CleaningStatus cleaningStatus={cleaningStatus} />;
        case 'PROGRESS_STATUS_POTENTIAL':
          return <PotentialStatus potentialStatus={potential?.potentialStatus} transactionProbability={potential?.transactionProbability} />;
        case 'PROGRESS_STATUS_ORDER':
          return getMessage(order?.orderStatus, 'FusedOrderStatus');
        default:
          return '-';
      }
    }
    return '-';
  };

  const renderColumn = (type: string, name: string, value: any, data: any) => {
    if (type === 'head') {
      return value;
    }
    switch (name) {
      case 'leadCreateTime':
      case 'distributeTime':
        return <DateTime dateTime={value} />;
      case 'systemSourceType':
        return <OriginalSourceInfo sourceType={value} />;
      case 'progressStatus':
        return getMessage(value, 'ProgressStatus');
      case 'cleaningStatus':
        return renderStatus(value, data);
      case 'ownerId':
        return <UserInfo webApi={webApi} userId={value} />;
      case 'followOperatorList':
        if (value && !_.isEmpty(value)) {
          return value.join(',');
        }
        return '-';
      case 'potential':
        const { potential } = data;
        if (potential?.ownerId) {
          return <UserInfo webApi={webApi} userId={potential?.ownerId} />;
        }
        return '-';
      default:
        return value || '-';
    }
  };

  const handleCreatLead = () => {
    const callingInfo = {
      Caller, Callee, CallTime, CallId, vendor,
    };
    window.open(computeGetUrl(`${REACT_APP_PUBLIC_URL}/leads/create?callingInfo=${encodeURIComponent(JSON.stringify(callingInfo))}`));
  };

  const handleChangeOptional = (event: any, value: number[]) => {
    const _selectedId = selectedId === value ? undefined : value;
    setSelectedId(_selectedId);
  };

  // 切换资讯类型
  const handleLgCallLabel = (_callTags: any) => {
    // const bool = callTags?.firstTag === _callTags?.firstTag;
    setCallTags(_callTags);
  };

  const radilCanOptional = () => {
    const { items: leadList = [] } = dialInData.leadList || {};
    if (!selectedId) {
      setDisabledValue([]);
      setCallTags({ firstTag: undefined, secondTag: undefined });
      setCanChoseList(_.map(lgCallLabelMap, (tag) => tag));
      return;
    }
    // 是否为直销服务商线索判定
    const ifDirectCustomer = _.includes(whiteList.data, _.filter(leadList, (v) => v.leadId === selectedId)[0]?.agencyId);
    if (ifDirectCustomer) {
      setCallTags({ firstTag: lgCallLabelMap.direct_customer });
      setCanChoseList([lgCallLabelMap.direct_customer]);
    } else {
      setCallTags({ firstTag: lgCallLabelMap.agency_sub_customer });
      setCanChoseList([lgCallLabelMap.agency_sub_customer]);
    }
  };

  // 选择线索变更
  useEffect(() => {
    radilCanOptional();
  }, [selectedId]);

  const canOptional = () => {
    const { items: leadList = [] } = dialInData.leadList || {};
    // 直销服务商线索集合
    const directLeads = _.map(_.filter(leadList, (v) => _.includes(whiteList.data, v.agencyId)), (d) => d.leadId);
    // 非直销服务商线索集合
    const noDirectLeads = _.map(_.filter(leadList, (v) => !_.includes(whiteList.data, v.agencyId)), (d) => d.leadId);
    if (callTags?.firstTag === lgCallLabelMap.direct_customer) {
      setDisabledValue(noDirectLeads);
      return;
    }
    if (callTags?.firstTag === lgCallLabelMap.agency_sub_customer) {
      setDisabledValue(directLeads);
      return;
    }
    if (!callTags?.firstTag) {
      setDisabledValue([]);
      return;
    }
    setDisabledValue(_.map(leadList, (v) => v.leadId));
  };

  // 咨询类型变更
  useEffect(() => {
    canOptional();
  }, [callTags.firstTag]);

  const renderLeadList = () => {
    const { items: leadList = [], conf } = dialInData.leadList || {};
    return (
      <>
        <Table className="fix-height-table" data={leadList}>
          <Column type="optional" target="leadId" disabledValue={disabledValue} value={selectedId} onOptionalChange={handleChangeOptional} fixedable />
          {
            _.map(columnConfig, (column, i) => {
              return <Column key={i} name={column.name} render={renderColumn}>{column.label}</Column>;
            })
          }
        </Table>
        <PageBar showPageJudge={false} value={conf.pageIndex + 1} pageSize={conf.pageSize || 20} totalSize={conf.totalCount || 0} onChange={handleChangePage} />
        <p className="dial-creat-lead">
          不是关联线索？
          <Button
            onClick={handleCreatLead}
            disabled={!params.isAnswered || (callTags?.firstTag && !_.includes([lgCallLabelMap.direct_customer, lgCallLabelMap.agency_sub_customer], callTags?.firstTag))}
            displayType="primary"
          >
            点击新建线索
          </Button>
        </p>
      </>
    );
  };

  /**
   * @description: 关联线索
   */
  const handleRelationLead = (data: any) => {
    if (disabled) return;
    disabled = true;
    webApi
      .dialInLead()
      .ajaxJson({
        data: {
          contactPhone: Caller,
          lead: {
            leadId: data.leadId,
            agencyId: data.agencyId,
          },
          create: false,
          dialInTime: CallTime,
          callId: CallId,
        },
      })
      .then((res: any) => {
        disabled = false;
        if (res.code === 0) {
          fetchTraceCalling({ ...res.data, ...data });
          message.success('成功');
          onClose();
        } else {
          message.strongwarn(res?.message);
        }
      })
      .catch((err: any) => {
        disabled = false;
        message.strongwarn(err?.message);
      });
  };

  const fetchTraceCalling = (data: any) => {
    webApi
      .dialInTraceCalling()
      .ajaxJson({
        data: {
          leadId: data.leadId,
          sessionId: CallId,
          dialDirection: 'DIAL_DIRECTION_IN',
          callingStatus: 'CALLING_STATUS_IN_AGENT_CONNECT',
          actionRecordList: data.actionRecordList || [],
          contactPhone: Caller,
          vendor,
          displayNumber: Caller,
          uuid: uuid(),
        },
      })
      .then((res: any) => {
        // 判断当前线索状态，跳转详情
        let linkUrl = '/leads';
        switch (data.progressStatus) {
          case 'PROGRESS_STATUS_POTENTIAL':
            linkUrl = '/potentials';
            break;
          case 'PROGRESS_STATUS_ORDER':
            linkUrl = '/orders';
            break;
          default:
            linkUrl = '/leads';
            break;
        }
        window.open(computeGetUrl(`${REACT_APP_PUBLIC_URL}${linkUrl}/${data.leadId}?agencyId=${data.agencyId}`));
      });
  };

  // 保存标签
  const saveCallTag = () => {
    const { items: leadList = [] } = dialInData.leadList || {};
    const param = {
      dialInFirstTagType: callTags?.firstTag,
      dialInSecondTagType: callTags?.secondTag,
      memoTag,
      callId: CallId,
    };
    callIdTagSave({ data: param })
      .then((res) => {
        if (res.code === 0) {
          if (selectedId) {
            const [data] = _.filter(leadList, (v) => v.leadId === selectedId);
            if (!data) {
              onClose();
              message.success('成功');
              return;
            };
            handleRelationLead(data);
          } else {
            message.success('成功');
            onClose();
          }
        }
      });
  };

  const onClose = () => {
    setShow(false);
    props?.onClose(Caller);
  };

  const onSubmit = () => {
    if (!callTags?.secondTag) {
      modal.error('请选择呼叫标签');
      return;
    }
    saveCallTag();
  };

  if (!_.isEmpty(dialInData)) {
    return (
      <Dialog
        {...props}
        className={'dial-in-modal'}
        title="电话呼入"
        show={show}
        type='normal'
        moveable
        onClose={onClose}
        onCancel={onClose}
        onSubmit={onSubmit}
        disabled={!isAnswered}
      >
        {renderDialHead()}
        {renderLeadList()}
        <FormGroup>
          <label>资讯类型：</label>
          <LGCallLabelRadioGroup useCanChose canChoseList={canChoseList} callTags={callTags || {}} onChange={handleLgCallLabel} />
        </FormGroup>
        <FormGroup style={{ display: 'flex' }}>
          <label style={{ width: 60 }}>备注：</label>
          <textarea placeholder='请输入备注，限制100字' rows={3} cols={30} className="spaui-input" maxLength={100} value={memoTag || ''} onChange={(e) => setMemoTag(e.target.value)} />
        </FormGroup>
      </Dialog>
    );
  }

  return null;
};

export default DialInModal;
